
import React from 'react';

import styles from './styles.module.scss'

interface IColourBubble {
  color: string,
  size: number,
  opacity: number,
  position: number,
  active: boolean,
  onClick: any
}

export default function ColourBubble({ color, size, opacity, position, active, onClick }: IColourBubble) {
  return (
    <div 
      className={styles.bubble + ' ' + (active ? styles.active : '')}
      style={{backgroundColor: color, width: size, height: size, opacity: opacity, left: position}}
      onClick={onClick}
    >
      &nbsp;

      {/* { active ? 
        <div className={styles.activeBubble}>
          <div>&nbsp;</div>
        </div> 
        : <>&nbsp;</> } */}
    </div>
  )
};
